import React from 'react';

/** Edit masthead copy here — static, no animation. */
export const COMPANY_MASTHEAD_COPY = {
  eyebrow: 'SMARTRABBITZ / EST. 2017',
  headlineBefore: 'A product engineering company, ',
  headlineEmphasis: 'not',
  headlineAfter: ' a body shop.',
  body:
    'We build software systems for healthcare, fintech, edtech, and retail clients across India, the UK, and the US. Headquartered in Technopark, Trivandrum, with a team that ships production code, not slide decks.',
  chips: ['9+ YEARS', '7 PRODUCTS', '3 CONTINENTS', '14 INDUSTRIES']
};

/**
 * @param {{ className?: string }} props
 */
export default function CompanyMasthead({ className = '' }) {
  const { eyebrow, headlineBefore, headlineEmphasis, headlineAfter, body, chips } = COMPANY_MASTHEAD_COPY;

  return (
    <header className={`cep-masthead ${className}`.trim()} aria-label="About SmartRabbitz">
      <p className="cep-eyebrow cep-masthead__eyebrow">
        <span className="cep-eyebrow__rule" aria-hidden="true" />
        {eyebrow}
      </p>
      <h2 className="cep-masthead__headline">
        {headlineBefore}
        <em>{headlineEmphasis}</em>
        {headlineAfter}
      </h2>
      <p className="cep-masthead__body">{body}</p>
      <div className="cep-masthead__chips" aria-label="Company highlights">
        {chips.map((label) => (
          <span key={label} className="cep-masthead__chip">
            {label}
          </span>
        ))}
      </div>
      <div className="cep-masthead__divider" role="presentation" aria-hidden="true" />
    </header>
  );
}
